import Box from '@zenbusiness/zui/Box';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import useBreakpoints from '@zenbusiness/zui/useBreakpoints';

import CheckRoundedIcon from '@mui/icons-material/CheckRounded';

import { PRODUCT_CATALOG_SERVICES } from '#client/constants/catalogServices';
import useOrderTaskContext from '#client/hooks/useOrderTaskContext';
import { findLatestOrderTaskByServiceName } from '#client/utils/orderTasks';

const HOURS_BEFORE_SHOWING_CONTACT_NUMBER = 48;

const CONTENT = {
  confirmation: 'You\u2019ve requested Bank of America contact you',
  contactText:
    'Should you get disconnected or need to get in touch with Bank of America after you are contacted, you can reach them at',
  contactNumber: '(866) 504-9670'
};

/**
 * Confirmation shown once the customer has opted in, with Bank of America's number surfacing after
 * enough time has passed that they may not have been contacted yet.
 * @returns {import('react').ReactElement} The confirmation
 */
export default function BankOfAmericaRequestedStatus() {
  const { theme } = useBreakpoints();
  const { orderTasks } = useOrderTaskContext();

  const latestOfferOrder = findLatestOrderTaskByServiceName(
    orderTasks,
    PRODUCT_CATALOG_SERVICES.BANK_OF_AMERICA_OFFER
  );
  const hoursSinceRequest = latestOfferOrder?.createdAt
    ? (Date.now() - new Date(latestOfferOrder.createdAt).getTime()) / (1000 * 60 * 60)
    : 0;

  return (
    // Owns its own gap: the modal's container used to supply it, the offer card does not.
    <Stack sx={{ gap: 3 }}>
      <Box
        sx={{
          borderRadius: '0.25rem',
          padding: '0.5rem 1rem',
          margin: '0 auto',
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem',
          backgroundColor: '#D9FEC5'
        }}
      >
        <CheckRoundedIcon sx={{ fill: theme.palette.text.green }} />
        <Text
          color="green"
          size="sm"
          weight="bold"
        >
          {CONTENT.confirmation}
        </Text>
      </Box>
      {hoursSinceRequest >= HOURS_BEFORE_SHOWING_CONTACT_NUMBER && (
        <Text
          color="secondary"
          size="sm"
        >
          {CONTENT.contactText}{' '}
          <Text
            color="blue"
            component="span"
            whiteSpace="nowrap"
          >
            {CONTENT.contactNumber}
          </Text>
          .
        </Text>
      )}
    </Stack>
  );
}

export { CONTENT as BANK_OF_AMERICA_REQUESTED_CONTENT };
